import api from './api';
import { ApiResponse } from '../types/common';
import { AlbaExam, OnlineApplicant, AlbaPool } from '../types/alba';

export const albaService = {
  // 등록된 일용직 목록 조회
  getAlbaList: async (params?: {
    chkDate?: string;
    startDate?: string;
    endDate?: string;
    jobName?: string;
    searchName?: string;
  }): Promise<ApiResponse<any[]>> => {
    const queryParams = new URLSearchParams(params as any);
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const response = await api.get(`/api/alba/list${queryString}`);
    return response.data;
  },

  // 온라인 모집공고 목록 조회
  getOnlineExamList: async (): Promise<ApiResponse<AlbaExam[]>> => {
    const response = await api.get('/alba/onlineExamList');
    return response.data;
  },

  // 온라인 지원자 목록 조회
  getOnlineApplicantList: async (examIdxList: number[], companyName: string): Promise<ApiResponse<OnlineApplicant[]>> => {
    const response = await api.post('/alba/onlineApplicantList', {
      examIdxList,
      companyName,
    });
    return response.data;
  },

  // 지원자 엑셀 다운로드
  downloadApplicantsExcel: async (applicantsData: any[]): Promise<Blob> => {
    const response = await api.post('/alba/downloadApplicantsExcel',
      { applicantsData },
      { responseType: 'blob' }
    );
    return response.data;
  },

  // 인력풀 목록 조회
  getPoolList: async (): Promise<ApiResponse<AlbaPool[]>> => {
    const response = await api.get('/alba/poolList');
    return response.data;
  },

  // 근로내역확인신고서 생성
  generateWorkReport: async (year: number, month: number): Promise<Blob> => {
    const response = await api.post('/api/alba/generateWorkReport',
      { year, month },
      { responseType: 'blob' }
    );
    return response.data;
  },

  // 통계 생성
  generateStatistics: async (startDate: string, endDate: string): Promise<Blob> => {
    const response = await api.post('/api/alba/generateStatistics',
      { startDate, endDate },
      { responseType: 'blob' }
    );
    return response.data;
  },

  // 일용직 등록 (인력풀 + 일용직 DB 저장)
  insertAlba: async (data: {
    Job_Name: string;
    S_Date: string;
    E_Date: string;
    Alba_Name: string;
    Alba_Jumin: string;
    Alba_Cell: string;
    Alba_Cost: number;
  }): Promise<ApiResponse<any>> => {
    const response = await api.post('/api/alba/insert', data);
    return response.data;
  },

  // 이름 검색
  searchByName: async (name: string): Promise<ApiResponse<any[]>> => {
    const response = await api.get(`/api/alba/searchName?name=${encodeURIComponent(name)}`);
    return response.data;
  },

  // Excel 업로드
  uploadExcel: async (data: any[]): Promise<ApiResponse<any>> => {
    const response = await api.post('/api/alba/uploadExcel', { data });
    return response.data;
  },

  // 인력풀 수정
  updatePool: async (data: {
    Alba_Name: string;
    Alba_Jumin: string;
    Alba_Cell: string;
  }): Promise<ApiResponse<any>> => {
    const response = await api.post('/api/alba/poolUpdate', data);
    return response.data;
  },

  // 인력풀 등록
  insertPool: async (data: {
    Alba_Name: string;
    Alba_Jumin: string;
    Alba_Cell: string;
  }): Promise<ApiResponse<any>> => {
    const response = await api.post('/api/alba/poolInsert', data);
    return response.data;
  },

  // 인력풀 삭제
  deletePool: async (Alba_IDX: number): Promise<ApiResponse<any>> => {
    const response = await api.post('/api/alba/poolDelete', { Alba_IDX });
    return response.data;
  },
};
